class ViewMoreGallery extends HTMLElement {
	connectedCallback() {
		const targetSel = this.getAttribute('target');
		this.gallery = document.querySelector(targetSel);
		if (!this.gallery) return;

		const sourceId = this.getAttribute('data-source');
		const jsonEl = document.getElementById(sourceId);
		this.images = jsonEl ? JSON.parse(jsonEl.textContent) : [];
		this.batchSize = parseInt(this.gallery.dataset.batch) || 6;
		this.mode = this.gallery.dataset.mode || 'button';
		this.currentIndex = 0;

		// Build UI
		if (this.mode === 'button') {
		this.button = document.createElement('button');
		this.button.type = 'button';
		this.button.className = 'view-more button button-secondary';
		this.button.textContent = this.getAttribute('label') || 'View More';
		this.button.addEventListener('click', () => this.showMore());
		this.replaceChildren(this.button);
		} else {
		// Infinite scroll: use IntersectionObserver sentinel
		this.sentinel = document.createElement('div');
		this.sentinel.className = 'gallery-sentinel';
		this.replaceChildren(this.sentinel);
		this.observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
			if (entry.isIntersecting) this.showMore();
			});
		}, { root: null, rootMargin: '200px 0px', threshold: 0 });
		this.observer.observe(this.sentinel);
		}

		if (!this.images.length) this.cleanup();
	}

	showMore() {
		if (this.currentIndex >= this.images.length) return this.cleanup();

		const nextBatch = this.images.slice(this.currentIndex, this.currentIndex + this.batchSize);
		nextBatch.forEach((item, index) => {
		const wrapper = document.createElement('div');
		wrapper.className = 'gallery-item';
		wrapper.innerHTML = item.html;
				wrapper.classList.add("fade-in");
			wrapper.style.animationDelay = `${index * 100}ms`;

		this.gallery.appendChild(wrapper);
		});

		this.currentIndex += this.batchSize;

		if (this.currentIndex >= this.images.length) this.cleanup();
	}

	cleanup() {
		if (this.observer) {
		this.observer.disconnect();
		if (this.sentinel) this.sentinel.remove();
		}
		if (this.button) this.button.style.display = 'none';
	}
}

customElements.define('view-more-gallery', ViewMoreGallery);